<template>
<div>
	<div class="d-flex justify-content-between mb-2">
		<h3 style="margin-bottom: 0">
			<i v-if="showCollapseButton" v-on:click="$emit('collapseSummary')" class="fa fa-chevron-right icon-button"></i>
			Bid Summary
		</h3>
		<a v-if="!hideNewTabLink" :href="'/project-bid-summary/' + $route.params.tag" target="_blank">Open Bid Summary in Separate Tab</a>
	</div>

	<table class="table table-sm">
		<thead>
			
		</thead>
		<tbody v-for="section in bidComponentsNested">
			<tr class="bg-light" :class="{'active-section' : selectedTopComponentId == section.id}">
				<th colspan="5">{{ section.name }}</th>
				<th class="text-right">{{ section.totalPriceRaw.toCurrency() }}</th>
			</tr>
			<tr>
				<th>Item #</th>
				<th>Spec #</th>
				<th>Description</th>
				<th class="text-right">Qty</th>
				<th class="text-right">Unit Price</th>
				<th class="text-right">Total Price</th>
			</tr>
			<template v-for="comp in section.JobBidComponent" >
				<tr :class="{'active-section' : selectedComponentId == comp.id}" class="top-level-component">
					<td :title="comp.is_reverse_calculated == 1 && comp.unitPriceRaw.countDecimals() > 2 ? 'This component\'s unit price is not a round number, so the Total Price is subject to rounding errors' : false">
						<i v-if="comp.is_reverse_calculated == 1 && comp.unitPriceRaw.countDecimals() > 2" class="fa fa-exclamation text-warning"></i>
						{{ comp.item_number }}
					</td>
					<td>{{ comp.spec_number }}</td>
					<td>{{ comp.name }}<span v-if="comp.description">: {{ comp.description }}</span></td>
					<td class="text-right">{{ comp.qty }}</td>
					<td class="text-right" :title="comp.unitPriceRaw">{{ comp.unitPriceRaw.toCurrency() }}</td>
					<td class="text-right">{{ comp.totalPriceRaw.toCurrency() }}</td>
				</tr>
				<template v-if="'JobBidComponent' in comp && comp.JobBidComponent">
					<tr v-for="subComp in comp.JobBidComponent"
						:class="{'active-section' : selectedComponentId == subComp.id}">

						<td>
							<i v-if="subComp.is_reverse_calculated == 1 && subComp.unitPriceRaw.countDecimals() > 2" class="fa fa-exclamation text-warning"></i>
							<span class="text-right">{{ subComp.item_number }}</span>
						</td>
						<td>{{ subComp.spec_number }}</td>
						<td>{{ subComp.name }}<span v-if="subComp.description">: {{ subComp.description }}</span></td>
						<td class="text-right">{{ subComp.qty }}</td>
						<td class="text-right" :title="subComp.unitPriceRaw">{{ subComp.unitPriceRaw.toCurrency() }}</td>
						<td class="text-right">{{ subComp.totalPriceRaw.toCurrency() }}</td>
				
					</tr>
				</template>
				
			</template>
		</tbody>
		<tfoot>
			<tr style="font-size: 14pt;border-top: 1px solid gray;">
				<th colspan="5" class="text-right">Total Bid Value:</th>
				<th class="text-right">{{ totalBidValue.toCurrency() }}</th>
			</tr>
		</tfoot>
	</table>
</div>
</template>
<script type="text/javascript">

import ProjectBidMixins from "@/mixins/ProjectBidMixins.js"
	
export default {
	name: "ProjectBidSummary",
	components: {

	},
	mixins: [ProjectBidMixins],
	props: [
		"bidProp",
		"showCollapseButton",
		"selectedTopComponentId",
		"selectedComponentId",
		"hideNewTabLink"
	],
	data() {
		return {
			
		}
	},
	watch: {
		bidProp() {
			if (this.bidProp && "id" in this.bidProp)
				this.fetchAllComponents(this.bidProp.id)
		},
		'$store.projectBidObjects'() {
			if (this.bidProp && "id" in this.bidProp)
				this.fetchAllComponents(this.bidProp.id)
		}
	},
	computed: {
		totalBidValue() {
			return this.bidComponentsNested.reduce((acc,topComp) => acc + topComp.totalPriceRaw,0)
		}
	},
	methods: {
		
		
	},
	created() {
		if (this.bidProp && "id" in this.bidProp)
			this.fetchAllComponents(this.bidProp.id)

		console.log(this.bidComponentsNested)

	}
}
</script>

<style scoped>
	.active-section {
		background-color: var(--brand-primary-color-faded)!important;
	}

	.top-level-component {
		font-weight: bold;
	}
</style>